import api from './api';

export const login = async (credentials) => {
    try {
        const response = await api.post('/auth/login', credentials);
        const { token, user, success } = response.data;

        if (success && token) {
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            localStorage.setItem('token', token);
            localStorage.setItem('auth', JSON.stringify({ token, user }));
        }

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const logout = () => {
    api.defaults.headers.common['Authorization'] = '';
    localStorage.removeItem('token');
    localStorage.removeItem('auth');
    localStorage.removeItem('adminSessionId');
};

// 다른 인증 관련 함수들... 